import axios from 'axios';
import { authHeaders, getAutomateApiUrl, isAuthOwnedPath } from './apiBase';
import { clearAuthSession } from '../auth/storage';

let installed = false;

const AUTH_401_SKIP = [
  '/auth/login',
  '/auth/register',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/microsoft-sso',
  '/auth/google-sso',
];

function shouldSkipUnauthorizedRedirect(url) {
  const path = String(url || '');
  return AUTH_401_SKIP.some((suffix) => path.includes(suffix));
}

/** Redirect or clear session when PyBE returns 401. */
export function handleAutomateUnauthorized() {
  clearAuthSession();
  window.location.href = '/login';
}

/** Install once — axios response interceptor for Automate API host. */
export function installAutomateHttpInterceptors() {
  if (installed) return;
  installed = true;
  const automateOrigin = getAutomateApiUrl().replace(/\/$/, '');

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const url = String(error?.config?.url || '');
      if (
        status === 401
        && url.startsWith(automateOrigin)
        && !shouldSkipUnauthorizedRedirect(url)
        && !isAuthOwnedPath(url)
      ) {
        handleAutomateUnauthorized();
      }
      return Promise.reject(error);
    },
  );

  axios.interceptors.request.use((config) => {
    const url = String(config.url || '');
    if (!url.startsWith(automateOrigin) || isAuthOwnedPath(url)) return config;
    const headers = authHeaders(config.headers || {});
    return { ...config, headers };
  });
}

export function isAutomateUnauthorizedError(error) {
  return error?.response?.status === 401;
}
